// src/components/LoadingScreen.tsx
"use client";

import { useState, useEffect } from "react";

export default function LoadingScreen({
  children,
}: {
  children: React.ReactNode;
}) {
  const [loading, setLoading] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const handleStart = () => {
      setLoading(true);
      setFadeOut(false); // Reset fade-out on new route change
    };

    const handleComplete = () => {
      // Add delay for fade-out
      setTimeout(() => setFadeOut(true), 1000); // Start fade-out after 1 second
      setTimeout(() => setLoading(false), 2000); // Hide loading after fade-out
    };

    // Simulate router events using window events for route changes
    window.addEventListener("next:router:routeChangeStart", handleStart);
    window.addEventListener("next:router:routeChangeComplete", handleComplete);
    window.addEventListener("next:router:routeChangeError", handleComplete);

    return () => {
      window.removeEventListener("next:router:routeChangeStart", handleStart);
      window.removeEventListener(
        "next:router:routeChangeComplete",
        handleComplete
      );
      window.removeEventListener(
        "next:router:routeChangeError",
        handleComplete
      );
    };
  }, []);

  if (loading) {
    return (
      <div
        className={`loading-screen w-full h-screen flex items-center justify-center flex-col transition-opacity duration-1000 ${
          fadeOut ? "opacity-0" : "opacity-100"
        }`}
      >
        <img
          src="https://i.ibb.co/k8ySvs5/logo3.png"
          className="w-1/6"
          alt="Logo"
        />
        <p className="text-brown-300 font-[300] text-sm mt-2">
          Please wait while we load the content for you...
        </p>
        <div className="spinner border-t-brown-500 border-2 border-solid border-brown-200 rounded-full w-7 h-7 mt-2"></div>
      </div>
    );
  }

  return <>{children}</>;
}
